import React from "react";
import Button from "@mui/material/Button";
import { FilterList } from "@mui/icons-material";
import { caseConstants } from "@_constants/case.constants";
import filterConfig from "./filterConfig";
import styles from "./ActiveFilterButton.module.css";

function ActiveFilterButton({ activeFilter, onClick }) {
  const config = filterConfig[activeFilter];
  const Icon = config ? config.icon : FilterList;
  const label = config ? config.label : "Filter";

  if (activeFilter !== caseConstants.CASE_FILTER_NONE && !config) {
    return null;
  }

  return (
    <Button
      onClick={onClick}
      className={styles.filterIconActive}
      data-testid="active-filter-button"
    >
      <Icon />
      <b className={styles.label}>{label}</b>
    </Button>
  );
}

export default ActiveFilterButton;
